import { IMAGE_URL_PREFIX } from "../constants";

export type ImageVariant = "productPrimaryImage";

export const makeImageUrl = (imageId: string, variantId: ImageVariant = "productPrimaryImage") => {
  const variant = variantId ? `/${variantId}` : "";
  return `${IMAGE_URL_PREFIX}${imageId}${variant}`;
};
